var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCluster(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_895",
    "data-name": "Gruppe 895",
    transform: "translate(-1499 -342)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_288",
    "data-name": "Ellipse 288",
    cx: 20,
    cy: 20,
    r: 20,
    transform: "translate(1499 342)",
    fill: "#005851"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vereinigungsmenge_50",
    "data-name": "Vereinigungsmenge 50",
    d: "M-13072.5,12425v-3.5h-3.5v-2h3.5v-3.5h2v3.5h3.5v2h-3.5v3.5Z",
    transform: "translate(14600.766 -12066.122)",
    fill: "#d9e868"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_883",
    "data-name": "Gruppe 883",
    transform: "translate(126.532 748.585) rotate(-30)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_871",
    "data-name": "Gruppe 871",
    transform: "translate(1388.289 361.646)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vereinigungsmenge_49",
    "data-name": "Vereinigungsmenge 49",
    transform: "translate(3.548)",
    fill: "#005851"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 10.39159393310547 6.891602993011475 L 1.000003457069397 6.891602993011475 L 1.000003457069397 1.000003218650818 L 10.39159393310547 1.000003218650818 C 12.13204383850098 1.000003218650818 13.54800319671631 2.321723222732544 13.54800319671631 3.946333169937134 C 13.54800319671631 5.57036304473877 12.13204383850098 6.891602993011475 10.39159393310547 6.891602993011475 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 10.39159393310547 5.891602993011475 C 11.58064365386963 5.891602993011475 12.54800319671631 5.01896333694458 12.54800319671631 3.946333169937134 C 12.54800319671631 2.873123168945312 11.58064365386963 2.000003099441528 10.39159393310547 2.000003099441528 L 2.000003576278687 2.000003099441528 L 2.000003576278687 5.891602993011475 L 10.39159393310547 5.891602993011475 M 10.39159393310547 7.891602993011475 L 3.505706899886718e-06 7.891602993011475 L 3.505706899886718e-06 3.165435828123009e-06 L 10.39159393310547 3.165435828123009e-06 C 12.68742370605469 3.165435828123009e-06 14.54800319671631 1.766073107719421 14.54800319671631 3.946333169937134 C 14.54800319671631 6.122383117675781 12.68742370605469 7.891602993011475 10.39159393310547 7.891602993011475 Z",
    stroke: "none",
    fill: "#d9e868"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_291",
    "data-name": "Ellipse 291",
    transform: "translate(0 0.001)",
    fill: "#005851",
    stroke: "#d9e868",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.548,
    cy: 3.945,
    rx: 3.548,
    ry: 3.945,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.548,
    cy: 3.945,
    rx: 2.548,
    ry: 2.945,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_872",
    "data-name": "Gruppe 872",
    transform: "translate(1390.271 352.959)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vereinigungsmenge_49-2",
    "data-name": "Vereinigungsmenge 49",
    transform: "translate(3.547)",
    fill: "#005851"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 8.483630180358887 6.891602993011475 L 0.9999999403953552 6.891602993011475 L 0.9999999403953552 1.000003218650818 L 8.483630180358887 1.000003218650818 C 10.01165962219238 1.000003218650818 11.25479984283447 2.321723222732544 11.25479984283447 3.946333169937134 C 11.25479984283447 5.57036304473877 10.01165962219238 6.891602993011475 8.483630180358887 6.891602993011475 Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 8.483630180358887 5.891602993011475 C 9.460260391235352 5.891602993011475 10.25479984283447 5.01896333694458 10.25479984283447 3.946333169937134 C 10.25479984283447 2.873123168945312 9.460260391235352 2.000003099441528 8.483630180358887 2.000003099441528 L 1.99999988079071 2.000003099441528 L 1.99999988079071 5.891602993011475 L 8.483630180358887 5.891602993011475 M 8.483630180358887 7.891602993011475 L -7.858276518390994e-08 7.891602993011475 L -7.858276518390994e-08 3.165435828123009e-06 L 8.483630180358887 3.165435828123009e-06 C 10.56309986114502 3.165435828123009e-06 12.25479984283447 1.766073107719421 12.25479984283447 3.946333169937134 C 12.25479984283447 6.122383117675781 10.56309986114502 7.891602993011475 8.483630180358887 7.891602993011475 Z",
    stroke: "none",
    fill: "#d9e868"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_283",
    "data-name": "Ellipse 283",
    transform: "translate(0 0.001)",
    fill: "#005851",
    stroke: "#d9e868",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.548,
    cy: 3.945,
    rx: 3.548,
    ry: 3.945,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.548,
    cy: 3.945,
    rx: 2.548,
    ry: 2.945,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_880",
    "data-name": "Gruppe 880",
    transform: "translate(1383.019 355.429)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_283-2",
    "data-name": "Ellipse 283",
    transform: "translate(0)",
    fill: "#005851",
    stroke: "#d9e868",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.548,
    cy: 3.945,
    rx: 3.548,
    ry: 3.945,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.548,
    cy: 3.945,
    rx: 2.548,
    ry: 2.945,
    fill: "none"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCluster);
export default __webpack_public_path__ + "static/media/Cluster.570e9f334e667fa1774df47f8b17de13.svg";
export { ForwardRef as ReactComponent };